import React, {forwardRef, ReactNode} from "react";
import ThemeData from "../../../Interfaces/ThemeData";
import {Button} from "react-bootstrap";

interface ThemesPopupItemPlayerContainerProps {
    theme: ThemeData,
    onThemeSelect: (theme: ThemeData) => void,
    children: ReactNode
}

const ThemesPopupItemPlayerContainer: React.FC<any> = forwardRef(({
                                                                                           theme,
                                                                                           onThemeSelect,
                                                                                           children
                                                                                       }, ref) => {
    return (
        <div>
            {children}
            <Button
                className={'selectThemeButton'}
                variant="primary"
                onClick={() => {
                    onThemeSelect(theme)
                }}
            >Выбрать эту тему</Button>
        </div>
    );
})
export default ThemesPopupItemPlayerContainer;